<template src="./ButtonAddComponent.html"></template>
<script>
export default {
  name: 'ButtonAddComponent',
  props: {
    label: {
      type: String,
      required: false,
      default: () => ''
    },
    width: {
      type: String,
      required: false,
      default: () => '120px'
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
  .btn-add {
      color: #3aac5d;
      border-color: #3aac5d;
      background: transparent;
      width: 120px;
  }
  .btn-add:hover {
    color: #fff;
    background-color: #696cff;
    border-color: #696cff;
    box-shadow: 0 0.125rem 0.25rem 0 rgba(113, 221, 55, 0.4);
    transform: translateY(-1px);
  }
</style>
